import React, { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import { InputField, TextAreaField } from "../../../form/input-fields";
import IconBtn from "../../../form/icon-btn";
import { AddNewScreenIcon, DeleteIcon } from "../../../svg";
import { SelectInput } from "../../../form/select-input";
import IconTextBtn from "../../../form/icon-text-btn";
import { MACHINE_TYPE_OPTIONS } from "../../../../utils/constants";


const MachineFields = ({ nestIndex, control, register, errors, headerDetails }: any) => {

  const [additionalDetails, setAdditionalDetails] = useState({});
  
    useEffect(() => {
      if (headerDetails?.additionalDetails) {
        try {
          const parsed = JSON.parse(headerDetails.additionalDetails);
          setAdditionalDetails(parsed);
        } catch (e) {
          console.error("Failed to parse additionalDetails:", e);
        }
      }
    }, [headerDetails]);
    
  const { fields, append, remove } = useFieldArray({
    control,
    name: `segmentDetails.${nestIndex}.machineDetails`,
  });

  return (
    <div className="w-full mb-4">
      <div className="flex justify-between items-center mb-2">
        <label className="text-[1.6rem] font-semibold">Machines</label>
        <IconTextBtn
          icon={<AddNewScreenIcon />}
          label="Add Machine"
          btnSize="large"
          handleClick={() => append({ machineName: "", machineType: "" })}
        />
      </div>
      {
        fields.length > 0 &&
        <br />
      }
      {fields.map((machine, machineIndex) => (
        <>
          <div key={machine.id} className="relative border rounded-md p-3 my-3">
          
            <button
              type="button"
              onClick={() => remove(machineIndex)}
              className="absolute -top-3 -right-3 w-9 h-9 flex items-center justify-center rounded-full bg-gray-200 text-red-500 hover:text-red-700 transition-shadow shadow-md z-50"
              title="Delete Machine"
            >
              <IconBtn icon={<DeleteIcon />} size="w-[1.0rem]" />
            </button>

            
            <div className="grid grid-cols-2 gap-4 mb-4">
              {/* Machine Name */}
              <InputField
                labelName="Machine Name"
                type="text"
                id={`segmentDetails.${nestIndex}.machineDetails.${machineIndex}.machineName`}
                isRequired={true}
                formHandle={register(`segmentDetails.${nestIndex}.machineDetails.${machineIndex}.machineName`, {
                  required: "Machine name is required",
                })}
                error={errors?.segments?.[nestIndex]?.machineDetails?.[machineIndex]?.name?.message}
              />

              {/* Machine Type */}
              <SelectInput
                labelName="Machine Type"
                idName={`segmentDetails.${nestIndex}.machineDetails.${machineIndex}.machineType`}
                name={`segmentDetails.${nestIndex}.machineDetails.${machineIndex}.machineType`}
                control={control}
                isRequired={true}
                options={MACHINE_TYPE_OPTIONS}
                error={errors?.segmentDetails?.[nestIndex]?.machineDetails?.[machineIndex]?.type?.message}
              />

              {/*Addresses */}
              <div className="flex flex-col gap-2 mb-4" style={{ display: (additionalDetails as any)?.hideMachineDetails?.addresses  === 1 ? "none" : "block", }}>
                <TextAreaField
                labelName="Addresses"
                type="text"
                id={`segmentDetails.${nestIndex}.machineDetails.${machineIndex}.addresses`}
                isRequired={true}
                formHandle={register(`segmentDetails.${nestIndex}.machineDetails.${machineIndex}.addresses`, {
                  required: "Addresses is required",
                })}
                error={errors?.segments?.[nestIndex]?.machineDetails?.[machineIndex]?.name?.message}
              />
              </div>
              
            </div>

          </div>
          <br />
        </>
      ))}
    </div>
  );
};

export default MachineFields;